import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Icon from "./Icon";
import { COMPANY, telHref } from "../content/site";
import s from "./Header.module.css";

export const NAV = [
  { to: "/nabidka", label: "Skladové vozy" },
  { to: "/dovoz", label: "Dovoz na míru" },
  { to: "/cisteni", label: "Čištění" },
  { to: "/o-nas", label: "O nás" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
    <header className={s.header}>
      <div className={`container ${s.row}`}>
        <Link to="/" className={s.logo} aria-label="VoltNaPřání — úvod">
          <img src="/favicon.png" alt="" width="40" height="40" />
          <span>VoltNaPřání</span>
        </Link>

        <nav className={s.nav} aria-label="Hlavní navigace">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => `${s.link} ${isActive ? s.active : ""}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className={s.actions}>
          <a href={telHref(COMPANY.phone)} className={s.phone}>
            <Icon name="phone" size={16} />
            <span className="num">{COMPANY.phone}</span>
          </a>
          <Link to="/dovoz" className={`btn btn-primary btn-sm ${s.cta}`}>Poptat dovoz</Link>
          <button
            type="button" className={s.burger}
            aria-expanded={open} aria-controls="mobile-menu"
            onClick={() => setOpen((o) => !o)}
          >
            <Icon name={open ? "x" : "menu"} size={22} />
            <span className="visually-hidden">{open ? "Zavřít menu" : "Otevřít menu"}</span>
          </button>
        </div>
      </div>
    </header>

      {/* Outside <header>: its backdrop-filter would make this fixed panel position
          relative to the 64 px header instead of the viewport. */}
      <div id="mobile-menu" className={`${s.drawer} ${open ? s.drawerOpen : ""}`} hidden={!open}>
        <nav aria-label="Mobilní navigace">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => `${s.drawerLink} ${isActive ? s.active : ""}`}>
              {n.label}
              <Icon name="chevron-right" size={18} />
            </NavLink>
          ))}
        </nav>
        <div className={s.drawerFoot}>
          <Link to="/dovoz" className="btn btn-primary btn-lg btn-block">Poptat dovoz na míru</Link>
          <a href={telHref(COMPANY.phone)} className="btn btn-ghost btn-lg btn-block">
            <Icon name="phone" size={18} /> <span className="num">{COMPANY.phone}</span>
          </a>
        </div>
      </div>
    </>
  );
}
